<div class="offer-bottom-popup">
  <!-- <ion-icon name="close-outline" (click)="close()"
    style="font-size: 2rem; position: fixed; color: #F5739F; z-index: 1; right: 20px;">
  </ion-icon> -->
  <ion-icon
    name="close-circle"
    class="padding-horizontal-5 close-i success-color closed"
    (click)="close()"
  ></ion-icon>
  <ion-card>
    <ion-card-header style="border-bottom: 1px solid #ccc">
      <ion-card-subtitle style="color: #01a3a4; font-size: 1.1rem">
        Fasting Time</ion-card-subtitle
      >
      <ion-card-title style="font-size: 0.8rem; font-weight: normal"
        >Choose your preferred fasting time
      </ion-card-title>
    </ion-card-header>
    <ion-card-content style="overflow-y: auto; max-height: 70vh">
      <div *ngFor="let duration of durations">
        <div class="duration" class="ion-margin-top">
          <div class="title" style="margin-left: 10px">
            {{ duration.level }}
          </div>
          <div class="sub-title" style="margin-left: 10px; margin-bottom: 5px">
            {{ duration.punchline }}
          </div>
          <div
            class="card"
            [ngStyle]="{ 'background-color': duration.color }"
            style="border-radius: 20px; color: white; height: 125px"
          >
            <ion-item
              lines="none"
              style="--background: transparent; color: white; font-size: 1.5rem"
              (click)="onCardSelect(duration.hours)"
            >
              <ion-label>
                {{ duration.fatingDuration }}
              </ion-label>
              <ion-icon
                slot="end"
                name="checkmark-circle"
                *ngIf="duration.isSelected"
                style="color: white; font-size: 2rem"
              ></ion-icon>
            </ion-item>
            <ion-item
              lines="none"
              style="--background: transparent; color: white; font-size: 0.8rem"
            >
              <ion-label
                style="
                  max-width: 200px;
                  text-overflow: unset;
                  white-space: unset;
                "
              >
                {{ duration.bottomLine }}
              </ion-label>
            </ion-item>
          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
